module.exports = __webpack_public_path__ + "assets/img/06.cbfce558.png";